"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('module-cropper', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48 33V23V13V9H4V43H8H18H28H38H48V33Z",
    fill: props.outFillColor
  }), _react.default.createElement("path", {
    d: "M60 55V45M60 55L48 43M60 55H50M48 13L60 25M48 13V23M48 13V9M48 43V33M48 43H38M8 43H18M8 43L20 55M8 43H4M60 25V35M60 25V15M48 23L60 35M48 23V33M60 35V45M48 33L60 45M38 43L50 55M38 43H28M50 55H40M28 43L40 55M28 43H18M40 55H30M18 43L30 55M30 55H20M20 55H10M48 9H4V43M48 9H54M4 43V49M54 9H60V15M54 9L60 15M4 49V55H10M4 49L10 55",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;